/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FaChevronRight } from 'react-icons/fa';

import tickIcon from '../../../images/consultations/processed.png';
import mapsIcon from '../../../images/consultations/gmap.png';
import StyledTappable from '../../common/StyledTappable';
import hospitalIcon from '../../../images/consultations/ord.png';

const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  padding: 13px 18px;
  margin: 0.625rem 0;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
`;

const IconTextContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Icon = styled.img`
  width: 1rem;
  height: 1rem;
  margin-right: 0.5rem;
`;

const VerticalContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ResponseContainer = styled.div`
  display: flex;
  align-items: center;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

const TitleTextContainer = styled.div`
  display: flex;
  flex: 1;
  overflow-x: hidden;
  padding-bottom: 12px;
  border-bottom: 1px dashed #d3d6db;
`;

const TitleText = styled.div`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const AngleRight = styled(FaChevronRight)`
  color: var(--primary-button);
  font-size: 14px;
  width: 8px;
`;

const DoctorSecondaryInfoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  margin-bottom: 10px;
  background: rgba(101, 68, 198, 0.05);
  border-radius: 6px;
  padding: 9px;
`;

const OfflineAppointmentConfirmedMessage = ({
  timetoken,
  doctorName,
  latitude,
  longitude,
  orgName,
  orgAddress,
  profileImage,
  appointmentTime,
  timingsIcon,
  clinicPayment,
  vertical,
  onTap,
}) => {
  return (
    <OuterContainer onClick={onTap}>
      <TitleContainer>
        <TitleTextContainer>
          <TitleText className="txt-black-600-12 flex-center">
            <img
              src={
                profileImage ||
                'https://s3.ap-south-1.amazonaws.com/visit-public/icons/doctor.png'
              }
              alt="dr."
              height={20}
              width={20}
            />
            <span className="pl-5">
              <span>{doctorName}</span>
              <br />
              <span className="txt-grey-10">{vertical}</span>
            </span>
          </TitleText>
          <AngleRight />
        </TitleTextContainer>
      </TitleContainer>

      <TitleContainer className="pt-10">
        <TitleText className="txt-black-600-12 flex-row-center-end">
          <span className="pl-5">
            <span>Appointment</span>
            <br />
            <span className="txt-grey-10">{appointmentTime}</span>
          </span>
          <span className="flex-center" style={{ flex: '0 1 auto' }}>
            <p style={{ color: '#1EB865' }}>Confirmed</p>

            <img
              className="pl-4"
              src={tickIcon}
              alt="status"
              width={'11px'}
              height={'11px'}
            />
          </span>
        </TitleText>
      </TitleContainer>
      <DoctorSecondaryInfoContainer className="mt-12">
        <ResponseContainer>
          <img src={hospitalIcon} alt={'org'} width={12} height={15} />
          <div className="txt-black-600-10 pl-8">{orgName}</div>
        </ResponseContainer>
      </DoctorSecondaryInfoContainer>
      <TitleContainer>
        <TitleTextContainer>
          <VerticalContainer>
            <IconTextContainer>
              <Icon src={mapsIcon} />
              <StyledTappable
                onTap={() => {
                  document
                    .querySelector(`#doctor-address-${timetoken}`)
                    .click();
                }}
              >
                <div className="txt-link-text">Get Directions</div>
                <a
                  href={`https://maps.mapmyindia.com/navigation?places=current_location;${latitude},${longitude},${orgName}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  id={`doctor-address-${timetoken}`}
                  style={{ display: 'none' }}
                />
              </StyledTappable>
            </IconTextContainer>
          </VerticalContainer>
        </TitleTextContainer>
      </TitleContainer>
      <TitleText className="txt-black-600-12 flex-row-center-end mt-8">
        <span className="pl-5">
          <span>Total Amount</span>
          <br />
          <span className="txt-black-500-10">to be paid by you</span>
        </span>
        <p>₹{clinicPayment}</p>
      </TitleText>
    </OuterContainer>
  );
};

OfflineAppointmentConfirmedMessage.propTypes = {
  timetoken: PropTypes.number,
  doctorName: PropTypes.string,
  orgName: PropTypes.string,
  latitude: PropTypes.string,
  longitude: PropTypes.string,
  orgAddress: PropTypes.string,
  profileImage: PropTypes.string,
  appointmentTime: PropTypes.string,
  timingsIcon: PropTypes.string,
  clinicPayment: PropTypes.number,
};

export default OfflineAppointmentConfirmedMessage;
